module.exports = __webpack_public_path__ + "static/media/strawberrysauce.138e84c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/flavor/strawberrysauce.jpg
// module id = 150
// module chunks = 0